const { getOffsetTop } = window.BAO.Utils

class HorizontalGallery extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.setupSizes = this.setupSizes.bind(this)
    this.peekAnimation = this.peekAnimation.bind(this)

    this.setupSizes()

    this.updateEl()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScroll, { passive: true })

    this.handleTrigger = this.handleTrigger.bind(this)
    this.listeners.add(this, 'click', this.handleTrigger)

    this.isMoreThanHalfVisible()
  }

  onScroll () {
    if (!window.BAO.MediaBreakpoints.isMd) return

    this.lastKnownY = window.scrollY

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.moveMedia()
  }

  setupSizes () {
    const roundedHeight = Math.round(this.mediaViewportPercent)

    this.style.setProperty(
      '--Media_Total',
      `${roundedHeight > 100 ? roundedHeight : 110}vh`,
    )
  }

  moveMedia () {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const maxScrollAmount = this.mediaViewportPercent - 100

    const elementHeight = this.offsetHeight

    const elementStartPoint = getOffsetTop(this)
    const elementEndPoint =
      getOffsetTop(this) + elementHeight - window.innerHeight

    if (this.lastKnownY <= elementStartPoint) {
      this.style.setProperty('--Scroll_Amount', `0vw`)

      return
    }

    if (this.lastKnownY > elementEndPoint) {
      this.style.setProperty('--Scroll_Amount', `-${maxScrollAmount}vw`)

      return
    }

    const totalScrollAmount = elementEndPoint - elementStartPoint

    const scrollYAsAPercentageOfJourney =
      (this.lastKnownY - elementStartPoint) / totalScrollAmount

    const scrollAmount = maxScrollAmount * scrollYAsAPercentageOfJourney

    this.style.setProperty('--Scroll_Amount', `-${scrollAmount}vw`)
  }

  handleTrigger (event) {
    if (!window.BAO.MediaBreakpoints.isMd) return

    const triggerEl = event.target.closest(
      '[data-horizontal-gallery-el="trigger"]',
    )

    if (!triggerEl) return

    window.drawers.activeDrawerKey = triggerEl.dataset.drawer

    const matchedZoomEl = this.querySelector(
      `[data-horizontal-gallery-el="zoom"][data-index="${triggerEl.dataset.index}"]`,
    )

    if (!matchedZoomEl) return

    matchedZoomEl.scrollIntoView({ behavior: 'instant' })
  }

  get mediaViewportPercent () {
    const mediaItemsWidth = [
      ...this.querySelectorAll('[data-horizontal-gallery-el="item"]'),
    ].reduce((accumulator, currentValue) => {
      return accumulator + currentValue.offsetWidth
    }, 0)

    const mediaWidthViewportPercent =
      (mediaItemsWidth / window.innerWidth) * 100

    return mediaWidthViewportPercent
  }

  peekAnimation (visible = false) {
    if (visible) {
      Array.from(this.els.item.elements)
        .slice(0, 2)
        .forEach((el) => {
          el.classList.add('sec-HorizontalGallery_Item-peek')
        })
    }
  }

  isMoreThanHalfVisible () {
    if (window.BAO.MediaBreakpoints.isMd) return
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          this.peekAnimation(
            entry.isIntersecting && entry.intersectionRatio > 0.95,
            entry,
          )
        })
      },
      {
        threshold: [0.95],
      },
    )

    observer.observe(this)

    return observer
  }
}

if (!customElements.get('horizontal-gallery')) {
  customElements.define('horizontal-gallery', HorizontalGallery)
}
